// Tiny i18n: 3 static dictionaries + {placeholder} interpolation.
// Locale is picked once (localStorage override, else ro) and exposed through
// the store; useT() reads it. Ignores navigator.language on purpose — the
// audience is a Romanian diaspora community whose devices are often set to
// Italian, not a signal that they'd prefer Italian in this app.

import en from "./en.json";
import it from "./it.json";
import ro from "./ro.json";

export const LOCALES = ["en", "it", "ro"] as const;
export type Locale = (typeof LOCALES)[number];

const DICTS: Record<Locale, Record<string, string>> = { en, it, ro };

export function detectLocale(): Locale {
  if (typeof window !== "undefined") {
    const stored = window.localStorage.getItem("locale");
    if (stored && (LOCALES as readonly string[]).includes(stored)) {
      return stored as Locale;
    }
  }
  return "ro";
}

// Translate key with optional {name} substitutions. Falls back to en, then key.
export function translate(
  locale: Locale,
  key: string,
  vars?: Record<string, string | number>,
): string {
  let s = DICTS[locale][key] ?? DICTS.en[key] ?? key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      s = s.replaceAll(`{${k}}`, String(v));
    }
  }
  return s;
}
